import { useState, useEffect } from 'react'
import GetUrls from 'ts/enums/Url'
import { Denomination } from 'ts/types'
import useModalStore from 'store/modal'
import { CheckBox, Input, CheckBoxToggle } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const DenominationAddPage = () => {
  const Url = GetUrls();
  const params = useModalStore((state) => state.params) as Denomination
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form
  const [isActive, setIsActive] = useState<boolean>(true);

  useEffect(() => {
    if (params) {
      setValue('denominationId', params.denominationId)
      setIsActive(params.flActive);
    }
  }, [params, setValue])

  const handleToggleActive = (isChecked: boolean) => {setIsActive(isChecked);}
  
  return (
    <ModalForm
      config={{ url: Url.postDenominations, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create new' } Denomination`}
      description='Create or edit a denomination'
    >

      {/* {params ? (
        <Input defaultValue={params.denominationId} label="ID" disabled />
      ) : null} */}

      <CheckBoxToggle 
        label="Active" 
        defaultChecked={isActive} 
        onToggle={handleToggleActive}
      />
      <Input
        label="Active" 
        className='hidden'
        {...register("flActive", { value : isActive ? 1 : 0 })}
      />
      <Input
        defaultValue={params?.denominationName || ''}
        label="Denomination Name"
        {...register('denominationName', { required: true })}
      />

      <Input
        defaultValue={params?.value || 0}
        type="number"
        label="Value"
        min={0}
        max={100}
        step={0.01}
        {...register('value', { required: true, min: 0, max: 100 })}
      />

      <Input
        defaultValue={params?.currencyName || ''}
        label="Currency"
        {...register('currencyName', { required: true })}
      />

      <Input
        defaultValue={params?.isoCurrencyCode || ''}
        label="ISO Code"
        {...register('isoCurrencyCode', { required: true })}
      />

      <CheckBox
        defaultChecked={params?.flNote || false}
        label="Notes?"
        {...register('flNote')}
      />
    </ModalForm>
  )
}

export default DenominationAddPage
